module.exports = __webpack_public_path__ + "assets/img/img184.8cab183c.png";